<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "app",
  created() {
    this.fingerprint();
  },
  mounted() {
    document.onkeydown = function() {
      var e = window.event || arguments[0];
      if (e.ctrlKey && e.keyCode == 85) {
        //禁止ctrl+u
        return true;
      }
    };
    document.oncontextmenu = function() {
      return true;
    };
  },
  methods: {
    fingerprint() {
      const visitorId = this.$cookies.get("visitorId");
      if (!visitorId) {
        // 设置cookie
        this.$cookies.set("visitorId", Date.now(), {
          expires: new Date(2100, 0, 1)
        });
      }
    }
  }
};
</script>

<style lang="less"></style>
